<template>
    <a-modal v-model:visible="show"
             loading
             centered
             wrapClassName="buy-dialog"
             :title="LAN.common.confirmBuy">
        <a-spin :spinning="loading">
            <div class="n-flex n-flex-s">
                <div class="list-thumb n-flex-s n-mr-4">
                    <NImage class="list-thumb-image n-col-1 n-h-1"
                            type="cover"
                            :zoomView="false"
                            :src="data.coverPicture">
                    </NImage>
                </div>

                <div class="n-flex-g n-flex-g-w-1-hack book-info">
                    <h1 class="n-f-bold n-c-4 n-m-0 n-line-height-1">{{ data.title || '-' }}</h1>

                    <h4 class="n-c-4 n-mb-0 n-mt-2 n-f-normal"
                        v-if="publication && publication.publishDate">
                        <label class="n-flex-s">{{ LAN.common.publishDate }}:&nbsp;&nbsp;</label>{{ publication ?
                                  parseCDate(publication.publishDate) : '-' }}
                    </h4>

                    <span class="n-block n-c-4"
                          v-if="publication && publication.isbn13">
                        <span class="n-flex-s">ISBN: {{ publication.isbn13 }}</span>
                    </span>

                    <span class="n-flex-s n-c-4"
                          v-if="publication && publication.size">{{ LAN.book.size1 }}: {{ publication.size }}</span>

                    <span class="n-block n-mt-2 n-f-10 n-c-base">{{ LAN.book.price }}: {{ data.publication.filter(item => item.mediumCode == 'EBook')[0].currency }}{{ formatNumber(data.publication.filter(item => item.mediumCode == 'EBook')[0].listPrice,2 ) }}</span>
                </div>

                <!-- <span class="n-f-10 n-c-base">
                {{ LAN.book.total }}: {{ data.publication.filter(item => item.mediumCode == 'EBook')[0].currency }}{{ data.publication.filter(item => item.mediumCode == 'EBook')[0].listPrice }}
            </span> -->
            </div>

            <div class="n-flex-g n-t-line n-mt-4 n-pt-5"
                 id="payment-element"></div>
        </a-spin>

        <template #footer>
            <div class="n-flex n-flex-a-c n-flex-j-e">
                <a-button class="c-tab-link c-tab-link-event"
                          @click="$emit('cancel')">{{ LAN.nui.common.cancel }}</a-button>
                <a-button type="primary"
                          class="c-tab-link c-tab-link-event"
                          :disabled="loading"
                          @click="confirmPay">{{ LAN.book.pay }}</a-button>
            </div>
        </template>
    </a-modal>
</template>
<script>
    import { mapMutations, mapState } from 'vuex';
    import NImage from '@/components/nui/NImage/NImage.vue'
    import nui from '@/assets/script';
    import { message } from 'ant-design-vue';


    export default {
        name: 'BookTable',
        props: {
            show: Boolean,
            data: { type: Array, default: () => { } },
            publication: { type: Array, default: () => { } }
        },
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                loading: false,
                stripe: null,
                elements: null
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            NMounted () {
                this.createPay()
            },
            createPay () {
                this.loading = true;

                this.request(this.API.pay, {
                    method: 'post',
                    params: { objId: this.publication.id, objType: "BOOK" }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.stripe = Stripe(res.data.pk);

                        this.elements = this.stripe.elements({
                            appearance: {
                                theme: 'stripe',
                            },
                            clientSecret: res.data.clientSecret
                        });

                        this.elements.create("payment", {
                            layout: "accordion",
                        }).mount("#payment-element");
                    } else {
                        message.error(res.msg, 3);
                    }

                    this.loading = false
                })
            },
            confirmPay () {
                this.loading = true;

                this.stripe.confirmPayment({
                    elements: this.elements,
                    confirmParams: {
                        return_url: location.protocol + '//' + location.host + "/paid?bid=" + this.data.id + "&pid=" + this.publication.id
                    },
                }).then((res) => {
                    if (res.error) {
                        console.log(111, res.error);
                    }

                    this.loading = false;
                });
            }
        }),
        components: {
            NImage
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .list-thumb {
        width: 130px;
        height: 187px;
    }
</style>
<style>
    .buy-dialog .ant-modal {
        width: 1002px !important;
        max-width: calc(100vw - 10px) !important;
    }
</style>